import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=3628455d&scoped=true"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"
import style0 from "./Item.vue?vue&type=style&index=0&id=3628455d&prod&scoped=true&lang=css"
import style1 from "./Item.vue?vue&type=style&index=1&id=3628455d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3628455d",
  null
  
)

export default component.exports